module.exports = __webpack_public_path__ + "media/images/just_skylines-57b86f660382e141b2a178350572346e.svg";